import './PetConfirmationDisplay.scss';
import { useContext, useEffect, useRef, useState } from 'react';
import { ReactComponent as PetCat } from '@/assets/img/v2/pet-cat-default-icon.svg';
import { ReactComponent as PetDog } from '@/assets/img/v2/pet-dog-default-icon.svg';
import { Pet } from '../types';
type PetConfirmationDisplayProps = {
  data?: Pet;
  showPrice: boolean;
};
export const PetConfirmationDisplay = ({ data, showPrice }: PetConfirmationDisplayProps) => {
  return (
    <div className={`pet-display`}>
      <div className="left-section">
        <div className="pets-profile-image">
          {data && data.petsImageUrl ? (
            <img src={data.petsImageUrl} />
          ) : data?.petType?.toLowerCase() === 'dog' ? (
            <PetDog />
          ) : (
            <PetCat />
          )}
        </div>
        <div className="details">
          <div className="name" title={data?.name}>
            {data?.name}
          </div>
          <span className="seperator"></span>
          <div className="breed" title={data?.breed}>
            {data?.breed}
          </div>
        </div>
      </div>
      {showPrice && data?.fee && (
        <div className="right-section">
          <span className="amount">+USD {data?.fee}</span>
        </div>
      )}
    </div>
  );
};
